const carouselItems = [
  {
    title: '热血江湖：风云再起',
    desc: '江湖路远，风云变幻。新一代少年踏上修炼之路，面对重重挑战与未知命运，热血与友情交织的传奇故事正式开启。羞羞歪歪漫画全集火热连载中。',
    tag: '热血',
    chapters: '已更新至186话',
    img: 'https://readdy.ai/api/search-image?query=A%20grand%20martial%20arts%20manga%20illustration%20with%20warm%20coral%20and%20golden%20tones%2C%20epic%20mountain%20landscape%20at%20sunset%2C%20dynamic%20character%20in%20flowing%20robes%20with%20sword%2C%20dramatic%20clouds%20and%20atmospheric%20lighting%2C%20traditional%20Chinese%20ink%20painting%20style%20blended%20with%20modern%20manga%20aesthetic&width=1200&height=600&seq=carousel-comic-01&orientation=landscape',
  },
  {
    title: '甜蜜陷阱：恋爱百分百',
    desc: '校园里的偶然邂逅，甜蜜又心动的日常。当冰山校草遇上元气少女，一段啼笑皆非的恋爱喜剧拉开帷幕。羞羞歪歪漫画竖屏阅读甜蜜加倍。',
    tag: '恋爱',
    chapters: '已更新至132话',
    img: 'https://readdy.ai/api/search-image?query=A%20sweet%20campus%20romance%20manga%20illustration%20with%20soft%20pink%20and%20peach%20tones%2C%20cherry%20blossom%20trees%20in%20full%20bloom%20along%20school%20path%2C%20two%20characters%20sharing%20a%20tender%20moment%2C%20warm%20sunlight%20filtering%20through%20petals%2C%20gentle%20watercolor%20texture&width=1200&height=600&seq=carousel-comic-02&orientation=landscape',
  },
  {
    title: '暗夜追踪：深渊之眼',
    desc: '连环悬案背后的惊天秘密，天才侦探与神秘组织的智力博弈。每一话都有反转，每一个细节都不能错过。羞羞歪歪漫画无删减完整呈现推理过程。',
    tag: '悬疑',
    chapters: '已更新至98话',
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20noir%20manga%20illustration%20with%20deep%20amber%20and%20shadowy%20tones%2C%20rainy%20city%20street%20at%20night%20with%20neon%20reflections%2C%20a%20silhouetted%20figure%20under%20streetlamp%2C%20dramatic%20film%20noir%20lighting%2C%20ink%20splash%20textures%20creating%20atmosphere&width=1200&height=600&seq=carousel-comic-03&orientation=landscape',
  },
  {
    title: '异界幻想：元素使者',
    desc: '平凡高中生意外穿越到元素世界，掌握五大元素之力，在奇幻大陆上开启冒险征程。羞羞歪歪漫画全部章节恢弘展开。',
    tag: '奇幻',
    chapters: '已更新至215话',
    img: 'https://readdy.ai/api/search-image?query=A%20fantastical%20isekai%20manga%20illustration%20with%20warm%20golden%20and%20amber%20tones%2C%20magical%20floating%20crystals%20and%20elemental%20energy%20swirls%2C%20a%20character%20surrounded%20by%20glowing%20auras%2C%20epic%20fantastical%20landscape%20with%20floating%20islands%2C%20vibrant%20warm%20color%20palette&width=1200&height=600&seq=carousel-comic-04&orientation=landscape',
  },
  {
    title: '都市传说：午夜画室',
    desc: '深夜画室里传出的神秘声音，一幅幅会动的画作背后隐藏着怎样的秘密？惊悚与温情并存的都市怪谈。羞羞歪歪漫画下拉式沉浸体验。',
    tag: '惊悚',
    chapters: '已更新至67话',
    img: 'https://readdy.ai/api/search-image?query=A%20haunting%20urban%20legend%20manga%20illustration%20with%20warm%20amber%20and%20deep%20shadow%20tones%2C%20old%20art%20studio%20at%20midnight%20with%20moonlight%20streaming%20through%20window%2C%20paintings%20on%20easels%20with%20mysterious%20glow%2C%20dust%20particles%20in%20light%20beam%2C%20atmospheric%20and%20eerie&width=1200&height=600&seq=carousel-comic-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-10">
          焦点专题推荐
        </h2>
        <div className="flex flex-col gap-6">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className={`group flex flex-col ${
                i % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
              } gap-6 bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer`}
            >
              <div className="lg:w-[480px] flex-shrink-0 aspect-[2/1] lg:aspect-auto overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 flex flex-col justify-center p-6 lg:p-8">
                <div className="flex items-center gap-3 mb-3">
                  <span className="px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-sm text-foreground-500">{item.chapters}</span>
                </div>
                <h3 className="text-xl md:text-2xl font-heading text-foreground-900 mb-3 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  {item.desc}
                </p>
                <a
                  href="#index"
                  className="inline-flex items-center gap-2 text-primary-500 hover:text-primary-600 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
                >
                  查看详情
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}